import { api } from "@/api";
import { ApiResponseType, PostVerificationCodeRequest, PostVerificationCodeResponse } from "@/api/type";

export const postVerificationCode = async(data: PostVerificationCodeRequest
) => {
    try {
        const res = await api.post<ApiResponseType<PostVerificationCodeResponse>>(`/api/web/visitors/verification-requests/verify`, data)
        return res.data;
    } catch (err) {
        console.error("postVerificationCode API error:", err)
        throw err;
    }
}